import c from "./TableContainer.module.scss";
import Pagination from "../utils/Pagination";
import FilterDropdown from "../utils/FilterDropdown";
import Table from "../utils/table/Table";
import { Link } from "react-router-dom";
import {
	getOrganizations,
	createOrganizationPlanRelation,
	updateOrganizationPlanRelation,
} from "../../services/organizations.service";
import { useEffect, useState } from "react";
import debounce from "lodash.debounce";
import LoadingBox from "../loading/LoadingBox";
import useLoadingHelper from "../../hooks/loading.hook";
import EmptyBox from "../emptystate/EmptyBox";
import { getAllResellerList } from "../../helper/data.helper";
import { ConfirmPlansFixModal } from "../popups/ConfirmPlansFixModal";
import { cn } from "../../lib/utils";

const defaultFilters = {
	page: 1,
	filter: {
		name: "",
		template_plan_active: null,
		organization_type_id: [],
		reseller_id: [],
	},
};

const INIT_CONFIRM_PLANS_FIX_PROPS = {
	open: false,
	organization: null,
	index: null,
	isLoading: false,
};

function TableConfEntities({ plan, onToggleChange, organizationTypesFilter, onAppyPreset }) {
	const { queueLoading, addQueue, removeQueue, initStatus, setInitStatus } = useLoadingHelper();

	const [organizations, setOrganizations] = useState([]);

	const [types, setTypes] = useState(organizationTypesFilter?.list ?? []);

	const [queryParams, setQueryParams] = useState(defaultFilters);

	const [resellers, setResellers] = useState([]);

	const [isResellerLoading, setIsResellerLoading] = useState(false);

	const [confirmPlansFixProps, setConfirmPlansFixProps] = useState(INIT_CONFIRM_PLANS_FIX_PROPS);

	const [pageData, setPageData] = useState({
		last: 0,
		current: 0,
		total: 0,
	});

	const getResellers = async () => {
		setIsResellerLoading(true);
		const resellers = await getAllResellerList({ per_page: 50 });
		setResellers(resellers);
		setIsResellerLoading(false);
	};

	/**
	 * Fetch data
	 */
	useEffect(() => {
		getListOrganizations();
	}, [queryParams]);

	useEffect(() => {
		getResellers();
	}, []);

	useEffect(() => {
		setTypes(organizationTypesFilter?.list ?? []);
	}, [JSON.stringify(organizationTypesFilter.list)]);

	/**
	 * Get List organizations
	 */
	const getListOrganizations = () => {
		const body = {
			...(plan && { template_plan_id: plan.id }),
			include: ["organizationType", "reseller", "organizationPlans"],
			...queryParams,
		};

		addQueue();

		// Fetch Api
		getOrganizations(
			body,
			(res) => {
				setOrganizations(res.data);

				removeQueue();

				setInitStatus(true);

				setPageData({
					last: res.meta.last_page,
					current: res.meta.current_page,
					total: res.meta.total,
				});
			},
			() => {
				removeQueue();
			}
		);
	};

	/**
	 * Update page
	 * @param {*} newPage
	 * @returns
	 */
	const updatePage = (newPage) => setQueryParams((q) => ({ ...q, page: newPage }));

	/**
	 * Debounce Search
	 */
	const debouncedSearch = debounce(onSearch, 300);

	/**
	 * Search event function
	 */
	function onSearch(e) {
		const searchModel = e.target.value;

		if (searchModel.trim().length > 0 || queryParams.filter.name != null) {
			setQueryParams((q) => ({
				...q,
				page: 1,
				filter: {
					...q.filter,
					name: searchModel.trim().length > 0 ? searchModel : "",
				},
			}));
		}
	}

	/**
	 * Active status
	 * @param {*} active
	 * @param {*} organization
	 */
	function activeOrganization(active, organization, index) {
		const hasIssues = organization?.template_plan_activation?.missing_template_plan_ids?.length > 0;
		hasIssues && setConfirmPlansFixProps((prevState) => ({ ...prevState, isLoading: true }));

		if (organization.organization_plans.length > 0) {
			updateOrganizationPlanRelation(
				{
					id: organization.id,
					idPlan: organization.organization_plans[0].id,
					active,
				},
				() => {
					getListOrganizations();
					onToggleChange();
					hasIssues && setConfirmPlansFixProps(INIT_CONFIRM_PLANS_FIX_PROPS);
				}
			);
		} else {
			if (active) {
				createOrganizationPlanRelation(
					{ id: organization.id, template_plan_id: plan.id, active },
					() => {
						getListOrganizations();
						onToggleChange();
						hasIssues && setConfirmPlansFixProps(INIT_CONFIRM_PLANS_FIX_PROPS);
					}
				);
			}
		}
	}

	const changeFilters = (key, item) =>
		setQueryParams((q) => ({
			...q,
			page: 1,
			filter: { ...q.filter, [key]: item },
		}));

	const resetFilter = () =>
		setQueryParams((q) => ({
			...defaultFilters,
			filter: { ...defaultFilters.filter, name: q.filter.name },
		}));

	return (
		<>
			<div className={c.main_intro}>
				<div className={c.left_content}>
					<div className={c.main_fitlers}>
						{/* Status filter */}
						<FilterDropdown
							options={[
								{ label: "Mostra tutti", value: null },
								{ label: "Attivi", value: true },
								{ label: "Inattivi", value: false },
							]}
							activeSelected={queryParams.filter.template_plan_active}
							onApply={(item) => {
								changeFilters("template_plan_active", item);
							}}
							toggleLabel="Stato"
							searchFilter={true}
							type="radio"
						/>

						{/* Type */}
						<FilterDropdown
							options={types.map((type) => ({
								label: type.name,
								value: type.id,
							}))}
							searchFilter={true}
							activeSelected={queryParams.filter.organization_type_id}
							onApply={(items) => changeFilters("organization_type_id", items)}
							toggleLabel="Tipologia"
						/>

						{/* Reseller */}
						{
							<FilterDropdown
								options={resellers.map((el) => ({
									label: el.name,
									value: el.id,
								}))}
								activeSelected={queryParams.filter.reseller_id}
								onApply={(items) => changeFilters("reseller_id", items)}
								toggleLabel="Rivenditori"
								searchFilter
								isLoading={isResellerLoading}
							/>
						}

						{(!!queryParams?.filter?.organization_type_id?.length ||
							!!queryParams?.filter?.reseller_id?.length ||
							queryParams?.filter?.template_plan_active !== null) && (
							<button className={c.main_reset} onClick={resetFilter} type="button">
								<div className={c.main_icon}>
									<span className="icon_16 default cross icon_mask !bg-interactive-100"></span>
								</div>
								Resetta
							</button>
						)}
					</div>
				</div>
				<div className={c.right_content}>
					<div className="wrap_input_landing icon">
						<input
							type="text"
							onChange={debouncedSearch}
							className="landing"
							placeholder="Ricerca..."
						/>
						<span className="icon_16 default search"></span>
					</div>
				</div>
			</div>

			<div className="relative">
				{organizations.length > 0 ? (
					<div className="fade_in">
						<Table>
							{/* Table Head */}
							<Table.Head>
								<Table.Column>Nome</Table.Column>
								<Table.Column>Tipologia</Table.Column>
								{/*<Table.Column>Rivenditore</Table.Column>*/}
								<Table.Column>Abilita</Table.Column>
								<Table.Column></Table.Column>
							</Table.Head>

							{/* Table Body */}
							<Table.Body>
								{organizations.map((el, index) => (
									<Table.Row key={index}>
										<Table.Cell width={400}>
											<div className="name_logo">
												{el.logo_url ? (
													<img src={el.logo_url} className="logo" alt="" />
												) : (
													<div className="main_icon">
														<span className="icon_16 default entity"></span>
													</div>
												)}
												<div className="">
													<div>{el.name}</div>
													{el?.reseller?.name && (
														<div className="text-12 text-dark-50">{el.reseller.name}</div>
													)}
												</div>
											</div>
										</Table.Cell>

										<Table.Cell width={""}>{el.organization_type.name}</Table.Cell>

										<Table.Cell width={80}>
											<div className={"flex gap-2 items-center"}>
												<div className="toggle_landing flex" key={el.id}>
													<input
														onChange={(e) =>
															activeOrganization(Number(e.target.checked), el, index)
														}
														checked={
															el.organization_plans.length > 0 && el.organization_plans[0].active
														}
														type="checkbox"
														id={`entity-${index}`}
														className="landing"
													/>
													<label
														htmlFor={
															!el.template_plan_activation.missing_template_plan_ids.length
																? `entity-${index}`
																: undefined
														}
														className="only_toggle"
														onClick={() => {
															if (
																el.template_plan_activation.missing_template_plan_ids.length > 0
															) {
																setConfirmPlansFixProps({ open: true, organization: el, index });
															}
														}}
														onKeyUp={(event) => {
															if (
																(event.key === "Enter" || event.key === " ") &&
																el.template_plan_activation.missing_template_plan_ids.length > 0
															) {
																setConfirmPlansFixProps({ open: true, organization: el, index });
															}
														}}
													>
														<span className="sr-only">Abilita piano per {el.name}</span>
													</label>
												</div>
												{el.template_plan_activation.missing_template_plan_ids.length > 0 && (
													<div className={"flex"}>
														<span className="icon_16 default wrench icon_mask !bg-interactive-100"></span>
													</div>
												)}
											</div>
										</Table.Cell>

										<Table.Cell width={100} key={el.organization_plans}>
											<div className={"flex gap-4"}>
												<button
													type={"button"}
													disabled={!el.organization_plans?.length}
													className={cn(
														"button line text-center x_small whitespace-nowrap",
														!el.organization_plans?.length && "disabled"
													)}
													onClick={() => onAppyPreset(el)}
												>
													Applica set dati
												</button>
												{el.organization_plans.length > 0 ? (
													<Link
														to={`/admin/plans/template/copy/${el.id}/${el.organization_plans[0].id}`}
														className="button fill secondary text-center x_small whitespace-nowrap"
													>
														Copia tra enti
													</Link>
												) : (
													<button
														disabled={true}
														className="button fill secondary text-center x_small disabled whitespace-nowrap"
														type="button"
													>
														Copia tra enti
													</button>
												)}
											</div>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>

						{/* Paginator */}
						<Pagination
							last={pageData.last}
							current={pageData.current}
							total={pageData.total}
							onChange={updatePage}
						/>
					</div>
				) : (
					initStatus && (
						<EmptyBox
							icon="icon_75 default archive_entity"
							title="Nessun risultato trovato"
							description="Qui visualizzerai la lista di tutti gli enti"
						/>
					)
				)}
				{queueLoading.length > 0 && <LoadingBox blocked={!initStatus} />}
			</div>

			{/* MODAL • Confirm plans fix */}
			<ConfirmPlansFixModal
				open={confirmPlansFixProps.open}
				setOpen={() => setConfirmPlansFixProps(INIT_CONFIRM_PLANS_FIX_PROPS)}
				organization={confirmPlansFixProps?.organization}
				onConfirm={() =>
					activeOrganization(1, confirmPlansFixProps?.organization, confirmPlansFixProps?.index)
				}
				isLoading={confirmPlansFixProps.isLoading}
			/>
		</>
	);
}

export default TableConfEntities;
